//
// Quantity selection
//
function initQuantitySelector() {
    $('<div class="quantity-button quantity-down">-</div>').insertBefore('.quantity input');
    $('<div class="quantity-button quantity-up">+</div>').insertAfter('.quantity input');
    $('.quantity').each(function() {
        var spinner = $(this);
        var input = spinner.find('input[type="number"]');
        var btnUp = spinner.find('.quantity-up');
        var btnDown = spinner.find('.quantity-down');
        var min = input.attr('min');
        var max = input.attr('max');

        btnUp.click(function() {
            var oldValue = parseFloat(input.val());
            var newVal = oldValue;
            if(oldValue >= max) {
                newVal = oldValue;
            } else {
                newVal = oldValue + 1;
            }
            spinner.find('input').val(newVal);
            spinner.find('input').trigger('change');
        });

        btnDown.click(function() {
            var oldValue = parseFloat(input.val());
            var newVal = oldValue;
            if(oldValue <= min) {
                newVal = oldValue;
            } else {
                newVal = oldValue - 1;
            }
            spinner.find('input').val(newVal);
            spinner.find('input').trigger('change');
        });
    });
}

$(function () {
    initQuantitySelector();
});
